import { render } from "./ClubsDashboard.vue?vue&type=template&id=907cbc0e&scoped=true"
import script from "./ClubsDashboard.vue?vue&type=script&lang=js"
export * from "./ClubsDashboard.vue?vue&type=script&lang=js"

import "./ClubsDashboard.vue?vue&type=style&index=0&id=907cbc0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907cbc0e"]])

export default __exports__